import React, { Component } from 'react';
import Meta from "../Meta";
import Header from "../components/Header";
import Footer from "../components/Footer";
import ListRender from "./ListRender";
import Loader from "../loader";
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";

export default class Galeries extends Component {

    render() {
        const context = this.props.context;
        const { org, config } = context;
        const title = t`Galeries Photo de ${org.name}`;
        const description = config["meta.description"] || t`Découvrez les galeries photo de ${org.name}`;

        return (
            <div className="travel-page travel-page--galeries">
                <Meta context={context} title={title} description={description} />
                {this.props.loading && <Loader />}
                <Header context={context} />

                <main className="travel-main">
                    <header className="tr-galeries__header">
                        <h1 className="tr-galeries__title">
                            <Trans>Galeries Photo</Trans>
                        </h1>
                        <p className="tr-galeries__subtitle">
                            <Trans>Revivez en images les moments forts de {org.name}</Trans>
                        </p>
                    </header>

                    <div className="travel-container">
                        <ListRender context={context} />
                    </div>
                </main>

                <style dangerouslySetInnerHTML={{ __html: `
                    .tr-galeries__header {
                        text-align: center;
                        padding: clamp(32px, 5vw, 56px) clamp(16px, 4vw, 32px) 8px;
                        max-width: 820px;
                        margin: 0 auto;
                    }
                    .tr-galeries__title {
                        margin: 0;
                        font-size: clamp(24px, 4vw, 40px);
                        font-weight: 800;
                        color: #1a1a2e;
                        line-height: 1.15;
                        letter-spacing: -.01em;
                        text-wrap: balance;
                    }
                    .tr-galeries__subtitle {
                        margin: 10px auto 0;
                        font-size: 16px;
                        color: #6b7280;
                        line-height: 1.5;
                        max-width: 640px;
                    }
                `}} />

                <Footer context={context} />
            </div>
        );
    }
}
